import React from 'react';

// @ts-expect-error: allow JS import
import Link from '../../../Link/Link';

import containerStyles from '../../AuthForms.module.less';

const ForgotPasswordSuccess: React.FC = () => (
  <div className={containerStyles.textCenter}>
    <h3>Thanks!</h3>
    <div>
      <p>If you provided a valid email, we&#39;ve sent you a link to change your password.</p>
      <p>
        If you are still unable to log in, please contact{' '}
        <Link href="/faq" target="_blank" rel="noopener noreferrer" inline>
          customer support
        </Link>{' '}
        for assistance.
      </p>
    </div>
  </div>
);

export default ForgotPasswordSuccess;
